import { pick } from 'lodash-es';
import { cdnAssetOptionsKeys } from '../../types/cdn-asset-options';
import { MoviexchangeMediaType } from './types/media-type';
export class MoviexchangeCdnClient {
    /**
     * Creates a movieXchange CDN Client instance.
     * @param configuration The configuration settings of the Moviexchange CDN client.
     */
    constructor(configuration) {
        this.configuration = configuration;
    }
    /**
     * URL builder for movieXchange Film assets.
     * @param releaseId The movieXchange release ID of the Film entity.
     * @param options Options for the Film's assets.
     */
    film(releaseId) {
        const urlBuilder = this.getUrlBuilderForEntity(releaseId);
        return {
            poster: urlBuilder(MoviexchangeMediaType.FilmPoster),
            backdrop: urlBuilder(MoviexchangeMediaType.FilmBackdrop),
            advertisement: urlBuilder(MoviexchangeMediaType.FilmAdvertisement),
            motionPoster: urlBuilder(MoviexchangeMediaType.FilmMotionPoster),
            still: urlBuilder(MoviexchangeMediaType.FilmStill),
            titleTreatment: urlBuilder(MoviexchangeMediaType.FilmTitleTreatment),
            trailer: urlBuilder(MoviexchangeMediaType.FilmTrailer),
            shortTrailer: urlBuilder(MoviexchangeMediaType.FilmTrailer) // MX Doesn't have an equivalent to short trailer
        };
    }
    /**
     * Constructs and returns a URL for a CDN asset.
     * @param mediaType The CDN media type for the asset.
     * @param releaseId The ID of the entity.
     * @param options Options for the asset.
     */
    getAssetUrl(mediaType, releaseId, options) {
        const url = this.configuration.url;
        const assetRoute = `release/${releaseId}/media/${mediaType}`;
        const optionsQuery = this.getQueryStringForOptions(options);
        return [url, assetRoute].join('/') + optionsQuery;
    }
    /**
     * Creates a URL builder for a given release.
     * @param releaseId The movieXchange release ID of the Film entity.
     * @param options The options for the media asset.
     */
    getUrlBuilderForEntity(releaseId) {
        return (mediaType) => (assetOptions) => this.getAssetUrl(mediaType, releaseId, assetOptions);
    }
    /**
     * Creates a query string for a CDN asset URL based on the supplied options.
     * @param options The options for the URL.
     */
    getQueryStringForOptions(options) {
        const queryParams = [];
        const validOptions = pick(options, cdnAssetOptionsKeys);
        for (const optionName in validOptions) {
            const value = validOptions[optionName];
            if (value !== undefined && value !== null) {
                queryParams.push(`${[optionName]}=${value}`);
            }
        }
        return queryParams.length === 0 ? '' : `?${queryParams.join('&')}`;
    }
}
//# sourceMappingURL=moviexchange-cdn-client.js.map